export enum ECommandValidationErrorCode {
  SpaceNotFound = 'SpaceNotFound',
  ShiftIsNotClosed = 'ShiftIsNotClosed',
  DuplicatedCategoryName = 'DuplicatedCategoryName',
}
